import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {error} from "@irati/ui/src/global/colors"
import {H4} from "@irati/ui/src//Typography/Heading"

export const Columns = styled.div`
  display: flex;
  overflow: visible;
  margin-top: ${padding.base};
`

export const Error = styled(H4)`
  color: ${error};
`

interface TableContainerProps {
  alignLeft?: boolean
}
export const TableContainer = styled.div<TableContainerProps>`
  text-align: ${({alignLeft}) => alignLeft ? "left" : "center"};
`
